const becomeAPartnerService = ({ email, firstName, lastName }) => {
  const data = {
    members: [
      {
        email_address: email,
        status: 'subscribed',
        merge_fields: {
          FNAME: firstName,
          LNAME: lastName,
        },
      },
    ],
  };
  const postData = JSON.stringify(data);
  return fetch(
    "https://dev-turfmutt.netlify.app/.netlify/functions/sendmail",
    {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',

      },
      body: postData,
    }
  );
};
export { becomeAPartnerService };
